import React, { useState, useRef } from "react";
import { NavLink } from "react-router-dom";
import "./Sidebar.scss";
import sidebarItems from "data/json/sidebarItems";
//svg
import setting from "assets/images/sidebar-icons/setting.svg";
import Administrativesettings from "assets/images/sidebar-icons/Administrativesettings.svg";

const Sidebar = () => {
  const hamburgerMenuIcon = useRef();
  const [showHamburgerMenu, setShowHamburgerMenu] = useState(false);
  // const sidebarItems = [
  //   {
  //     title: "مدیریت انبار",
  //     img: Warehousemanagement,
  //     submenu: [
  //       {
  //         to: "/warehouse/measurement-unit",
  //         src: measurementunit,
  //         name: "واحدهای سنجش",
  //       },
  //       {
  //         to: "/warehouse/commodity-and-services-group",
  //         src: Goodsandservicesgroup,
  //         name: "گروه های کالایی",
  //       },
  //       {
  //         to: "/warehouse/create-commodity-and-services",
  //         src: Goodsandservices,
  //         name: "ثبت کالاها",
  //       },
  //       {
  //         to: "/warehouse/commodity-and-services",
  //         src: Goodsandservices,
  //         name: "نمایش کالا و خدمات",
  //       },
  //       {
  //         to: "/warehouse/create-warehouse",
  //         src: Warehouse,
  //         name: "انبار ها",
  //       },
  //       {
  //         to: "/warehouse/persons",
  //         src: person,
  //         name: "اشخاص",
  //       },
  //       {
  //         to: "/warehouse/persons-group",
  //         src: person,
  //         name: "گروه اشخاص",
  //       },
  //     ],
  //   },
  //   {
  //     title: "اسناد انبار",
  //     img: Warehousedocuments,
  //     submenu: [
  //       {
  //         to: "/warehouse/create-warehouse-document/entry",
  //         src: WarehouseEntryDocument,
  //         name: "ثبت سند ورود انبار ",
  //       },
  //       {
  //         to: "/warehouse/create-warehouse-document/exit",
  //         src: Warehouseexitdocument,
  //         name: "ثبت سند خروج انبار",
  //       },
  //       {
  //         to: "/warehouse/warehouse-documents/entry",
  //         src: WarehouseEntryDocument,
  //         name: "اسناد ورودی انبار",
  //       },
  //       {
  //         to: "/warehouse/warehouse-documents/exit",
  //         src: Warehouseexitdocument,
  //         name: "اسناد خروجی انبار",
  //       }
  //     ]
  //   }
  // ];
  const closeHamburgerMnu = (e) => {
    e.preventDefault();
    hamburgerMenuIcon.current.checked = false;
    setShowHamburgerMenu(false);
  };
  return (
    <>
      <div className="hamburger-menu-container d-print-none">
        <input
          className="checkbox"
          type="checkbox"
          ref={hamburgerMenuIcon}
          onChange={() => setShowHamburgerMenu(!showHamburgerMenu)}
        />
        <div className="hamburger-lines">
          <span className="line line1"></span>
          <span className="line line2"></span>
          <span className="line line3"></span>
        </div>
      </div>

      <div className={`sidebar ${showHamburgerMenu ? "show-sidebar" : ""}`}>
        <div className="list-items-container">
          {/* <div className={`sidebar ${sidebarPin || sidebarExpand ? `pin-sidebar` : ''}`}
         onMouseEnter={() => setSidebarExpand(true)}
         onMouseLeave={() => setSidebarExpand(false)}
         > */}
          {/* <div className="pin-container">
                <img
                    src={sidebarPin ? emptyPin : fullPin}
                    onClick={() => setSidebarPin(!sidebarPin)}
                    alt="icon"
                />
            </div> */}
          {/* <ul className="list-items">
            <li className="list-item">
              <img src={Warehousemanagement} alt="" srcSet="" />
              <span className="list-item-text">مدیریت انبار</span>
            </li>
            <li
              className="list-item"
              onClick={(e) => {
                closeHamburgerMnu(e);
              }}
            >
              <NavLink
                to="/warehouse/measurement-unit"
                className={({ isActive }) =>
                  isActive ? "link active-link" : "link"
                }
              >
                <img
                  className="list-item-icon"
                  src={measurementunit}
                  alt="icon"
                />
                <span className="list-item-text">واحدهای سنجش</span>
              </NavLink>
            </li>
            <li
              className="list-item"
              onClick={(e) => {
                closeHamburgerMnu(e);
              }}
            >
              <NavLink
                to="/warehouse/commodity-and-services-group"
                className={({ isActive }) =>
                  isActive ? "link active-link" : "link"
                }
              >
                <img
                  className="list-item-icon"
                  src={Goodsandservicesgroup}
                  alt="icon"
                />
                <span className="list-item-text">گروه های کالایی</span>
              </NavLink>
            </li>
            <li
              className="list-item"
              onClick={(e) => {
                closeHamburgerMnu(e);
              }}
            >
              <NavLink
                to="/warehouse/create-commodity-and-services"
                className={({ isActive }) =>
                  isActive ? "link active-link" : "link"
                }
              >
                <img
                  className="list-item-icon"
                  src={Goodsandservices}
                  alt="icon"
                />
                <span className="list-item-text">ثبت کالاها</span>
              </NavLink>
            </li>
            <li
              className="list-item"
              onClick={(e) => {
                closeHamburgerMnu(e);
              }}
            >
              <NavLink
                to="/warehouse/commodity-and-services"
                className={({ isActive }) =>
                  isActive ? "link active-link" : "link"
                }
              >
                <img
                  className="list-item-icon"
                  src={Goodsandservices}
                  alt="icon"
                />
                <span className="list-item-text">نمایش کالا و خدمات</span>
              </NavLink>
            </li>
            <li
              className="list-item"
              onClick={(e) => {
                closeHamburgerMnu(e);
              }}
            >
              <NavLink
                to="/warehouse/create-warehouse"
                className={({ isActive }) =>
                  isActive ? "link active-link" : "link"
                }
              >
                <img className="list-item-icon" src={Warehouse} alt="icon" />
                <span className="list-item-text">انبارها</span>
              </NavLink>
            </li>
            <li
              className="list-item"
              onClick={(e) => {
                closeHamburgerMnu(e);
              }}
            >
              <NavLink
                to="/warehouse/persons"
                className={({ isActive }) =>
                  isActive ? "link active-link" : "link"
                }
              >
                <img className="list-item-icon" src={person} alt="icon" />

                <span className="list-item-text">اشخاص</span>
              </NavLink>
            </li>
            <li
              className="list-item"
              onClick={(e) => {
                closeHamburgerMnu(e);
              }}
            >
              <NavLink
                to="/warehouse/persons-group"
                className={({ isActive }) =>
                  isActive ? "link active-link" : "link"
                }
              >
                <img className="list-item-icon" src={person} alt="icon" />

                <span className="list-item-text">گروه اشخاص</span>
              </NavLink>
            </li>
          </ul>
          <ul className="list-items">
            <li className="list-item">
              <img src={Warehousedocuments} alt="" srcSet="" />
              <span className="list-item-text">اسناد انبار </span>
            </li>
            <li
              className="list-item"
              onClick={(e) => {
                closeHamburgerMnu(e);
              }}
            >
              <NavLink
                to="/warehouse/create-warehouse-document/entry"
                className={({ isActive }) =>
                  isActive ? "link active-link" : "link"
                }
              >
                <img
                  className="list-item-icon"
                  src={WarehouseEntryDocument}
                  alt="icon"
                />
                <span className="list-item-text">ثبت سند ورود انبار </span>
              </NavLink>
            </li>
            <li
              className="list-item"
              onClick={(e) => {
                closeHamburgerMnu(e);
              }}
            >
              <NavLink
                to="/warehouse/create-warehouse-document/exit"
                className={({ isActive }) =>
                  isActive ? "link active-link" : "link"
                }
              >
                <img
                  className="list-item-icon"
                  src={Warehouseexitdocument}
                  alt="icon"
                />
                <span className="list-item-text">ثبت سند خروج انبار </span>
              </NavLink>
            </li> */}
          {/* <li
              className="list-item"
              onClick={(e) => {
                closeHamburgerMnu(e);
              }}
            >
              <NavLink
                to="/warehouse/edit-warehouse-document/entry"
                className={({ isActive }) =>
                  isActive ? "link active-link" : "link"
                }
              >
                <img
                  className="list-item-icon"
                  src={WarehouseEntryDocument}
                  alt="icon"
                />
                <span className="list-item-text">ویریش سند ورود انبار </span>
              </NavLink>
            </li> */}

          {/* <li
              className="list-item"
              onClick={(e) => {
                closeHamburgerMnu(e);
              }}
            >
              <NavLink
                to="/warehouse/warehouse-documents/entry"
                className={({ isActive }) =>
                  isActive ? "link active-link" : "link"
                }
              >
                <img
                  className="list-item-icon"
                  src={WarehouseEntryDocument}
                  alt="icon"
                />
                <span className="list-item-text">اسناد ورودی انبار </span>
              </NavLink>
            </li>
            <li
              className="list-item"
              onClick={(e) => {
                closeHamburgerMnu(e);
              }}
            >
              <NavLink
                to="/warehouse/warehouse-documents/exit"
                className={({ isActive }) =>
                  isActive ? "link active-link" : "link"
                }
              >
                <img
                  className="list-item-icon"
                  src={Warehouseexitdocument}
                  alt="icon"
                />
                <span className="list-item-text">اسناد خروجی انبار </span>
              </NavLink>
            </li> */}
          {/* <li
              className="list-item"
              onClick={(e) => {
                closeHamburgerMnu(e);
              }}
            >
              <NavLink
                to="/warehouse/warehouse-opening-documents"
                className={({ isActive }) =>
                  isActive ? "link active-link" : "link"
                }
              >
                <img className="list-item-icon" src={opening} alt="icon" />
                <span className="list-item-text">اسناد افتتاحیه انبار </span>
              </NavLink>
            </li>
            <li
              className="list-item"
              onClick={(e) => {
                closeHamburgerMnu(e);
              }}
            >
              <NavLink
                to="/warehouse/warehouse-closing-documents"
                className={({ isActive }) =>
                  isActive ? "link active-link" : "link"
                }
              >
                <img className="list-item-icon" src={closing} alt="icon" />
                <span className="list-item-text">اسناد اختتامیه انبار </span>
              </NavLink>
            </li>
            <li
              className="list-item"
              onClick={(e) => {
                closeHamburgerMnu(e);
              }}
            >
              <NavLink
                to="/warehouse/warehouse-handling"
                className={({ isActive }) =>
                  isActive ? "link active-link" : "link"
                }
              >
                <img
                  className="list-item-icon"
                  src={Warehousehandling}
                  alt="icon"
                />
                <span className="list-item-text">انبار گردانی </span>
              </NavLink>
            </li>*/}
          {/* </ul> */}
          {/* <ul className="list-items">
            <li className="list-item">
              <img src={hesabdari} alt="" srcSet="" />
              <span className="list-item-text">حسابداری</span>
            </li>
            <li
              className="list-item"
              onClick={(e) => {
                closeHamburgerMnu(e);
              }}
            >
              <NavLink
                to="/2"
                className={({ isActive }) =>
                  isActive ? "link active-link" : "link"
                }
              >
                <img className="list-item-icon" src={Warehousenewdocuments} alt="icon" />
                <span className="list-item-text">ثبت سند جدید</span>
              </NavLink>
            </li>
            <li
              className="list-item"
              onClick={(e) => {
                closeHamburgerMnu(e);
              }}
            >
              <NavLink
                to="/1"
                className={({ isActive }) =>
                  isActive ? "link active-link" : "link"
                }
              >
                <img className="list-item-icon" src={Warehousealldocuments} alt="icon" />
                <span className="list-item-text">مشاهده تمام اسناد</span>
              </NavLink>
            </li>
          </ul>  */}
          {/* /// */}
          {/* <ul className="list-items">
            <li className="list-item">
              <img src={setting} alt="" srcSet="" />
              <span className="list-item-text">تنظیمات</span>
            </li> */}

          {/* <li
              className="list-item"
              onClick={(e) => {
                closeHamburgerMnu(e);
              }}
            >
              <NavLink
                to="/9"
                className={({ isActive }) =>
                  isActive ? "link active-link" : "link"
                }
              >
                <img
                  className="list-item-icon"
                  src={Collectionprofile}
                  alt="icon"
                />
                <span className="list-item-text">پروفایل مجموعه</span>
              </NavLink>
            </li> */}
          {/* ////////// */}
          {/* <li
              className="list-item"
              onClick={(e) => {
                closeHamburgerMnu(e);
                localStorage.clear();
                window.location.href = "/login";
              }}
            >
              <NavLink
                to="/5"
                className={({ isActive }) =>
                  isActive ? "link active-link" : "link"
                }
              >
                <img
                  className="list-item-icon"
                  src={Administrativesettings}
                  alt="icon"
                />
                <span className="list-item-text">خروج</span>
              </NavLink>
            </li>
          </ul> */}
         {sidebarItems.map((items) => {
            return (
              <ul className="list-items">
                <li className="list-item">
                  <img src={items.img} alt="" srcSet="" />
                  <span className="list-item-text">{items.title}</span>
                </li>
                {items.submenu.map((submenu) => {
                  return (
                    <li
                      className="list-item"
                      onClick={(e) => {
                        closeHamburgerMnu(e);
                      }}
                    >
                      <NavLink
                        to={submenu.to}
                        className={({ isActive }) =>
                          isActive ? "link active-link" : "link"
                        }
                      >
                        <img
                          className="list-item-icon"
                          src={submenu.src}
                          alt="icon"
                        />
                        <span className="list-item-text">{submenu.name}</span>
                      </NavLink>
                    </li>
                  );
                })}
              </ul>
            );
          })}
          <ul className="list-items">
            <li className="list-item">
              <img src={setting} alt="" srcSet="" />
              <span className="list-item-text">تنظیمات</span>
            </li>
            <li
              className="list-item"
              onClick={(e) => {
                closeHamburgerMnu(e);
                localStorage.clear();
                window.location.href = "/login";
              }}
            >
              <NavLink
                to="/5"
                className={({ isActive }) =>
                  isActive ? "link active-link" : "link"
                }
              >
                <img
                  className="list-item-icon"
                  src={Administrativesettings}
                  alt="icon"
                />
                <span className="list-item-text">خروج</span>
              </NavLink>
            </li>
          </ul>
        </div>
      </div>
    </>
  );
};

export default Sidebar;
